module.exports = __webpack_public_path__ + "img/vmc_aniv2_24Aug2021.d7971fd3.jpg";